module.exports = __webpack_public_path__ + "media/banks/bank-boa-a80be0ca.png";